define(function (require) {

    var App = window.App || {};
    var timerManager = window.timerManager || {};
    var ViewController = require('web-agent-framework/ViewController');


    ViewController.plugin({

        registerToTimer: function (registerToTimerObj) {

            if (window.App && window.App.timerManager) {
                registerToTimerObj.context = registerToTimerObj.context || this;
                var registerUniqueId = window.App.timerManager.registerTimer(registerToTimerObj);
                return registerUniqueId;
            }
        },

        unregisterTimer: function (unregisterToTimerObj) {
            unregisterToTimerObj.context = unregisterToTimerObj.context || this;
            window.App.timerManager.unregisterTimer(unregisterToTimerObj);
        }
    });

    // todo - what to export?

});
